import React from 'react'
import {
    StyledSubNavLinks,
    StyledSubNavExpandToggle,
    StyledSubNavList,
    StyledSubNavHeader,
    StyledSubNavHeaderLink,
    StyledSubNavHeaderChevron,
} from 'component-library/navigation/TheWestMainNavigation/components/sub_navigation/subNavigation.styled'
import { SubNavigationItem } from 'component-library/navigation/TheWestMainNavigation/components/sub_navigation/components/subNavigationItem'
import { NavEventArgs } from 'common/events/nav-event-types'

export interface SubNavLink {
    name: string
    link: string
}

export interface Section {
    sectionName: string
    sectionLink: string
    subNavLinks: SubNavLink[]
}

export interface Props {
    opened: boolean
    section: Section
    expandToggleClicked: () => void
    onClick?: (args: NavEventArgs) => void
}

export const SubNavigationSection: React.FC<Props> = ({
    section,
    opened,
    expandToggleClicked,
    onClick,
}) => {
    const links = section.subNavLinks.map((item, index) => (
        <SubNavigationItem
            key={index}
            children={item.name}
            link={item.link}
            onClick={(text, link) =>
                onClick && onClick({ navText: text, navLink: link, navParent: section.sectionName })
            }
        />
    ))

    return (
        <StyledSubNavList>
            <StyledSubNavHeader>
                <StyledSubNavHeaderLink
                    to={section.sectionLink}
                    onClick={() =>
                        onClick &&
                        onClick({ navText: section.sectionName, navLink: section.sectionLink })
                    }
                >
                    {section.sectionName}
                    <StyledSubNavHeaderChevron />
                </StyledSubNavHeaderLink>

                <StyledSubNavExpandToggle
                    isOpen={opened}
                    onClick={expandToggleClicked}
                    data-testid="subNav__expand-toggle"
                >
                    <span>{opened ? 'Hide' : 'Show'}</span>
                </StyledSubNavExpandToggle>
            </StyledSubNavHeader>

            <StyledSubNavLinks isOpen={opened}>{links}</StyledSubNavLinks>
        </StyledSubNavList>
    )
}
